module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "3pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _vm._v("This is a true story. Conversations and reflections were based on hundreds of hours of interviews. In the interest of privacy, some names and details have been changed, and in one case a composite character created.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c0d6bf30","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/06_thisistrue.vue
// module id = 75
// module chunks = 0